import { Delete, Add, Save, Edit } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Form, Formik, FormikProps } from "formik";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { FormikTextField } from "../../components/Layout/FormikTextField";
import { StyledTableRow, StyledTableCell } from "../../styles/tableStyles";
import { ClientTypes } from "../auth/types/authType";
import {
  addCompany,
  addSubAgent,
  getCompany,
  removeCompany,
  selectSetups,
} from "./setupSlices";

import { Company, Partner } from "./types/setupTypes";
import { createCompanySchema } from "./validation";
import Toast from "../../components/Layout/Toast";
import { StyledAccordionSummary } from "../../styles/componentStyled";

interface PartnersTabProps {
  companyId?: string | undefined;
}
const defaultCompany: Company = {
  displayName: "",
  email: Math.random().toString(36).slice(2, 12) + "@enjazplus.com",
  address: { telephone: "", alternateTelephone: "" },
};
export const SubAgentsEntry = ({ companyId }: PartnersTabProps) => {
  //const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [company, setSelectedAgency] = useState<Company>(defaultCompany);
  const {
    error,
    success,
    selectedCompany: companyProfile,
  } = useAppSelector(selectSetups);

  useEffect(() => {
    if ((companyId && companyId.length > 0) || success) {
      dispatch(getCompany(companyId as string));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, success]);

  // let partner: Partner = { displayName: "", email: "" };
  // let partners: Partner[] = [];
  const [partners, setPartners] = useState<Partner[]>([]);

  useEffect(() => {
    if (companyProfile && companyProfile.partners) {
      setPartners(
        companyProfile.partners?.map(
          (p) =>
            ({
              _id: p._id,
              displayName: p.displayName,
              email: p.email,
            } as Partner)
        ) as Partner[]
      );
    }
    if (success) ResetFields();
  }, [companyProfile]);

  const ResetFields = () => {
    setSelectedAgency({
      displayName: "",
      email: Math.random().toString(36).slice(2, 12) + "@enjazplus.com",
      address: { telephone: "", alternateTelephone: "" },
    });
  };

  const removePartner = (id: string) => {
    dispatch(removeCompany(id as string));
    dispatch(getCompany(companyId as string));
  };
  return (
    <>
      <Accordion sx={{ m: 1 }} expanded>
        <StyledAccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Sub Agents</Typography>
        </StyledAccordionSummary>

        <AccordionDetails>
          <Formik
            enableReinitialize={true}
            initialValues={company as Company}
            validationSchema={createCompanySchema}
            onSubmit={(values, actions) => {
              actions.setSubmitting(false);
              values = {
                ...values,
                type: ClientTypes.SubAgent,
                remarks: companyProfile._id,
              };
              // if (values && values._id) {
              //   dispatch(addCompany(values));
              //   // console.log(values._id);
              // }
              // else
              dispatch(addSubAgent(values));
            }}
          >
            {(props: FormikProps<Company>) => (
              <Form>
                <Grid container spacing={2} sx={{ p: 1 }}>
                  <Grid item md={6} xs={12}>
                    <FormikTextField
                      formikKey="displayName"
                      label="Agent Name"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormikTextField
                      formikKey="address.telephone"
                      label="Telephone"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      sx={{ py: 1 }}
                    >
                      <Tooltip title="Save Company">
                        <Button
                          type="submit"
                          color="secondary"
                          variant="contained"
                          fullWidth
                          disabled={!props.isValid}
                        >
                          Save
                        </Button>
                      </Tooltip>
                      <Tooltip title="Add New Company">
                        <Button
                          color="secondary"
                          variant="contained"
                          fullWidth
                          onClick={ResetFields}
                        >
                          Reset
                        </Button>
                      </Tooltip>
                    </Stack>
                  </Grid>
                </Grid>

                {success && <Toast severity="success">{success.message}</Toast>}
                {error && <Toast severity="error">{error.message}</Toast>}
              </Form>
            )}
          </Formik>

          <Grid container justifyContent="flex-start" sx={{ mt: 0 }}>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>S.No</StyledTableCell>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell>Telephone</StyledTableCell>
                    <StyledTableCell>Actions</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {companyProfile &&
                    companyProfile.partners &&
                    companyProfile.partners.map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell>{index + 1}</StyledTableCell>
                        <StyledTableCell>{row.displayName}</StyledTableCell>
                        <StyledTableCell>
                          {row.address?.telephone}
                        </StyledTableCell>

                        <StyledTableCell>
                          <Stack
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            spacing={2}
                          >
                            <IconButton
                              color="secondary"
                              onClick={() => setSelectedAgency(row)}
                              size="large"
                            >
                              <Edit />
                            </IconButton>
                            {/* <IconButton
                              color="error"
                              onClick={() => removePartner(row._id as string)}
                              size="large"
                            >
                              <Delete />
                            </IconButton> */}
                          </Stack>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* {companyData && (
        <Formik
          enableReinitialize={true}
          initialValues={partner as Partner}
          validationSchema={createCompanySchema}
          onSubmit={(values, actions) => {
            actions.setSubmitting(false);
            values = {
              ...values,
              type:
                companyData.type === ClientTypes.LocalAgency
                  ? ClientTypes.ForeignAgent
                  : ClientTypes.LocalAgency,
            };
            dispatch(addCompany(values));
          }}
        >
          {(props: FormikProps<Company>) => (
            <Form>
              <>
                <Grid container spacing={1}>
                  <Grid item md={6} xs={12}>
                    <FormikTextField formikKey="displayName" label="Name" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormikTextField formikKey="email" label="Email" />
                  </Grid>

                  <Grid item md={3} xs={12}>
                    {success && (
                      <Toast severity="success">{success.message}</Toast>
                    )}
                    {error && <Toast severity="error">{error.message}</Toast>}
                    <Button
                      sx={{ width: "100%", mt: 1 }}
                      type="submit"
                      color="secondary"
                      variant="contained"
                      disabled={
                        !props.isValid || loadingAddingPartner === "pending"
                      }
                    >
                      <Add />
                      Add New Partner
                    </Button>
                  </Grid>
                </Grid>
              </>
            </Form>
          )}
        </Formik>
      )} */}
    </>
  );
};
